<template>
  <div>
    <button class="button button-white" @click="dialogRefund = true">
      <b-icon icon="undo-variant" custom-size="mdi-18px"></b-icon>
      <span>{{ title }}</span>
    </button>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogRefund"
      :width="dialogWidth"
      class="refundDialog"
      :lock-scroll="true"
      @open="openDialog"
      @close="closeDialog"
    >
      <el-dialog
        class="refundResult"
        title="Возврат по следующим позициям"
        width="40%"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div>Email: {{ refundForm.email }}</div>
        <div class="u-16 ver-margin-15" style="border-top: 1px #ccc dashed"></div>
        <div v-for="(item, index) in refundGoods" :key="index" class="grid">
          <div class="u-10">
            <span>
              <strong>{{ item.name }}</strong>
            </span>
            <br />
            <span>Ставка:</span> <br />
            <span>Предмет расчета:</span> <br />
            <span>Способ расчета:</span>
          </div>
          <div class="u-6">
            <span>
              <strong>{{ (item.amount * 100) | amountFormat }} {{ currency }}</strong>
            </span>
            <br />
            <span>{{ item.tax | taxName }}</span> <br />
            <span>{{ item.payment_subject_type | subjectName }}</span> <br />
            <span>{{ item.payment_method_type | methodName }}</span>
          </div>
          <div class="u-16 ver-margin-15" style="border-top: 1px #ccc dashed"></div>
        </div>
        <div class="grid">
          <el-button @click="innerVisible = false">Отмена</el-button>
          <el-button type="success" @click="Refund(amount)" :loading="loading">Отправить</el-button>
        </div>
      </el-dialog>
      <div class="grid cross-center">
        <div class="u-16" v-if="!(isReceipt || isSplit)">
          <money v-model="amount" v-bind="money" class="u el-input__inner text-center"></money>
        </div>

        <div v-if="isReceipt" class="u-16 grid">
          <el-form
            :model="refundForm"
            ref="refundForm"
            label-width="70px"
            label-position="left"
            class="u-16 grid refundForm"
          >
            <el-form-item
              class="u-8"
              prop="email"
              label="Email"
              :rules="[
                {
                  required: true,
                  message: 'Пожалуйста введите email',
                  trigger: 'blur',
                },
                {
                  type: 'email',
                  message: 'введите корректный email',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input type="text" v-model="refundForm.email"></el-input>
            </el-form-item>

            <div class="u-16">
              <el-table ref="refundTable" :data="refundForm.goodsList" class="refundtable">
                <el-table-column type="expand">
                  <template slot-scope="scope" v-if="scope.row.supplier">
                    <div class="grid cross-center">
                      <div class="u-2">Поставщик:</div>
                      <div class="u-3">
                        <el-form-item label-width="0">
                          <el-input
                            type="text"
                            v-model="scope.row.supplier.name"
                            :ref="'supplierName' + scope.$index"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="grid cross-center ver-margin-10">
                      <div class="u-2">Инн:</div>
                      <div class="u-3">
                        <el-form-item label-width="0">
                          <el-input
                            type="text"
                            v-model="scope.row.supplier.inn"
                            :ref="'supplierInn' + scope.$index"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="grid cross-center">
                      <div class="u-2">Телефон:</div>
                      <div class="u-3">
                        <el-form-item label-width="0">
                          <el-input
                            type="text"
                            v-model="scope.row.supplier.phone_numbers"
                            :ref="'supplierPhone' + scope.$index"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column width="50">
                  <template slot="header" slot-scope="scope">
                    <el-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="handleCheckAllChange"
                    ></el-checkbox>
                  </template>

                  <template slot-scope="scope">
                    <div>
                      <el-form-item label-width="0">
                        <el-checkbox
                          v-model="scope.row.selected"
                          :value="scope.row.id"
                          @change="handleCheckedGoodsChange($event, scope.row)"
                        />
                      </el-form-item>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Наименование" min-width="180">
                  <template slot-scope="scope">
                    <el-form-item label-width="0">
                      <el-input type="text" v-model="scope.row.name" :ref="'goodsName' + scope.$index"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="Ставка" width="180">
                  <template slot-scope="scope">
                    <el-form-item label-width="0">
                      <el-select v-model="scope.row.tax" value-key="id" placeholder="Ставка">
                        <el-option v-for="el in goods.tax" :key="el.id" :label="el.value" :value="el.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="Предмет расчета">
                  <template slot-scope="scope">
                    <el-form-item label-width="0">
                      <el-select v-model="scope.row.payment_subject_type" value-key="id" placeholder="Предмет расчета">
                        <el-option
                          v-for="el in goods.subjectTypes"
                          :key="el.id"
                          :label="el.value"
                          :value="el.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="Способ расчета">
                  <template slot-scope="scope">
                    <el-form-item label-width="0">
                      <el-select v-model="scope.row.payment_method_type" value-key="id" placeholder="Способ расчета">
                        <el-option
                          v-for="el in goods.paymentMethod"
                          :key="el.id"
                          :label="el.value"
                          :value="el.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="Тип агена" v-if="hasAgentType">
                  <template slot-scope="scope">
                    <el-form-item label-width="0" v-if="scope.row.agent_type != 0">
                      <el-select v-model="scope.row.agent_type" value-key="id" placeholder="Тип агента">
                        <el-option
                          v-for="el in goods.agent_type"
                          :key="el.id"
                          :label="el.label"
                          :value="el.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="Сумма" width="180">
                  <template slot-scope="scope">
                    <el-form-item label-width="0">
                      <div class="el-input el-input--small">
                        <money
                          class="el-input__inner text-right"
                          v-bind="money"
                          v-model="scope.row.amount"
                          @input="handleInputAmount"
                        ></money>
                      </div>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="" width="55">
                  <template slot-scope="scope">
                    <el-button @click.prevent="removeGoods(scope.row)" icon="el-icon-delete" type="text"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form>
          <div class="u-16 grid between ver-margin-10">
            <el-button @click="addGoods">Добавить позицию</el-button>
            <div class="hor-padding-10">
              <strong> Сумма к возврату: {{ (amount * 100) | amountFormat }} {{ currency }} </strong>
            </div>
          </div>
        </div>

        <div v-if="showSplitTable()" class="u-16 grid">
          <split-table
            :key="transaction_id"
            :splitList="splitList"
            :currency="currency"
            @updateSplitTotal="updateSplitTotal"
          ></split-table>
          <div class="u-16 grid end hor-padding-10">
            <strong>Сумма к возврату: {{ splitAmount | amountFormat }}</strong>
          </div>
        </div>

        <el-alert v-if="showError" :closable="false" :title="errorMessage" type="error"></el-alert>
      </div>

      <span slot="footer" class="grid start">
        <el-button @click="dialogRefund = false">Отмена</el-button>
        <el-button type="primary" @click="submitForm" :loading="loading">Подтвердить</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { apiUrl } from "@/api/apiUrl";
import errors from "@/localize/errors.js";
import goods from "@/localize/goods.js";
import { _ } from "vue-underscore";
import { Money } from "v-money";

import splitTable from "./splitTable.vue";

export default {
  name: "refundDialog",
  props: {
    transaction_id: {
      type: Number,
      required: true,
    },
    merchantOrderId: {
      type: String,
    },
    amountOrder: {
      type: Number,
      required: true,
    },
    isReceipt: {
      type: Boolean,
      default: false,
      required: true,
    },
    isSplit: {
      type: Boolean,
      default: false,
      required: true,
    },
    splitList: {
      type: Array,
    },
    currency: {
      type: String,
      required: true,
      default: "₽",
    },
    orderGoods: {
      type: Array,
    },
    orderCP: {
      type: Array,
    },
    terminalTax: {
      type: [Boolean, Number],
    },
  },
  data() {
    return {
      activeTab: "goods",
      loading: false,
      title: "Возврат",
      dialogRefund: false,
      showControls: false,
      amountRefund: 0,
      refundForm: {
        email: "",
        goodsList: [],
      },
      goods: goods,
      selectedRows: [],
      checkAll: false,
      isIndeterminate: false,
      innerVisible: false,
      money: {
        decimal: ".",
        thousands: " ",
        prefix: "",
        suffix: " " + this.currency,
        precision: 2,
        masked: false,
      },
      showError: false,
      errorMessage: "Не выбрана ни одна позиция в товарах",
      checkSplitForm: false,
      splitAmount: 0,
      splitListRefund: [],
      hasAgentType: false,
    };
  },
  filters: {
    taxName(id) {
      if (id) return goods.tax.find((el) => el.id == id).value;
    },
    subjectName(id) {
      if (id) return goods.subjectTypes.find((el) => el.id == id).value;
    },
    methodName(id) {
      if (id) return goods.paymentMethod.find((el) => el.id == id).value;
    },
  },
  computed: {
    dialogWidth() {
      return this.isReceipt || this.isSplit ? "90%" : "300px";
    },
    dialogTitle() {
      return this.isReceipt || this.isSplit ? "Возврат по заказу: " + this.merchantOrderId : "Возврат";
    },
    amount: {
      get() {
        if (!this.isReceipt) {
          return this.amountRefund / 100;
        } else {
          let a = 0;
          this.refundForm.goodsList.forEach((el) => {
            if (el.selected) a = parseFloat(a + el.amount);
          });
          return a;
        }
      },
      set(value) {
        if (!this.isReceipt) this.amountRefund = value * 100;
      },
    },
    refundGoods() {
      return this.refundForm.goodsList.filter((el) => el.selected);
    },
  },
  methods: {
    Refund(amount) {
      var params = {
        transaction_id: this.transaction_id,
        amount: this.isSplit && !this.isReceipt ? Math.round(this.splitAmount) : Math.round(this.amount * 100),
        operation: "refund",
      };
      if (this.isReceipt) {
        let goods = "";
        this.refundGoods.forEach((el) => {
          goods =
            goods +
            el.name +
            "=" +
            Math.round(el.amount * 100) +
            "," +
            el.payment_subject_type +
            "," +
            el.tax +
            "," +
            el.payment_method_type;
          if (el.agent_type) {
            goods = goods + "," + el.agent_type;
          }
          if (el.supplier != "") {
            let supplier = {};
            if (el.supplier.name != "" && el.supplier.inn != "") {
              supplier = {
                name: el.supplier.name,
                supplierINN: el.supplier.inn,
              };
              if (el.supplier.phone_numbers) {
                supplier.phoneNumbers = el.supplier.phone_numbers.replace(" ", "").split(",");
              }
            }
            goods = goods + "|" + JSON.stringify(supplier) + ";";
          } else goods = goods + ";";
        });
        goods = goods.substring(0, goods.length - 1);
        _.extend(params, {
          Params: "Email=" + this.refundForm.email,
          Goods: goods,
        });
      }
      if (this.isSplit) {
        _.extend(params, { split: this.splitListRefund });
      }
      var config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token"),
        },
      };
      this.loading = true;
      axios
        .post(apiUrl + "transaction/operate", params, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.$message({
              message: "Возврат успешно выполнен",
              type: "success",
            });
            setTimeout(() => {
              this.$emit("loadAsyncData");
            }, 500);
            this.dialogRefund = false;
            this.innerVisible = false;
          } else {
            this.$message.error("(" + data.state_id + ") " + errors[data.error_code]);
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err.response);
          this.$message.error(errors[err.response.data.error_code]);
          this.loading = false;
        });
    },
    submitForm() {
      if (!this.isReceipt && !this.isSplit) {
        this.Refund(this.amount);
      } else {
        if (this.isSplit) {
          if (this.splitListRefund.length == 0) {
            this.showError = true;
            this.errorMessage = "Не выбраны сплиты для возврата";
          }
          if (this.splitAmount == 0) {
            this.showError = true;
            this.errorMessage = "Сумма возврата должна быть больше 0";
          }
          if (this.isReceipt && this.splitAmount != parseInt(this.amount * 100)) {
            this.showError = true;
            this.errorMessage = "Суммы возврата товаров и сплитов не совпадают";
          }
          if (this.showError) return false;
          if (!this.isReceipt) this.Refund(this.splitAmount);
        }
        if (this.isReceipt) {
          this.refundForm.goodsList = this.refundForm.goodsList.filter((el) => el.amount != 0 && el.name != "");
          this.showError = this.refundForm.goodsList.filter((el) => el.selected).length == 0;
          if (this.showError) return false;
          this.$refs["refundForm"].validate((valid) => {
            if (valid) {
              this.innerVisible = true;
            } else {
              return false;
            }
          });
        }
      }
    },
    focusName() {
      const last = this.refundForm.goodsList.length - 1;
      this.$refs["goodsName" + last].focus();
    },
    addGoods() {
      this.refundForm.goodsList.push({
        id: null,
        name: "",
        amount: 0,
        currency_code: 643,
        tax: this.terminalTax,
        selected: true,
        payment_subject_type: 1,
        payment_method_type: 4,
        agent_type: null,
        supplier: {
          name: "",
          inn: "",
          phone_numbers: "",
        },
      });
      this.showError = false;
      this.$nextTick(() => {
        this.focusName();
      });
    },
    removeGoods(item) {
      var index = this.refundForm.goodsList.indexOf(item);
      if (index !== -1) {
        this.refundForm.goodsList.splice(index, 1);
      }
    },
    openDialog() {
      if (this.isReceipt || this.isSplit) this.checkAll = true;
      this.amountRefund = this.amountOrder;

      const emailParam = this.orderCP.find((el) => el.k == "Email");
      this.refundForm.email = emailParam ? emailParam.v : "";

      const arr = this.orderGoods.map((a) => ({ ...a }));

      let countAgentType = 0;

      if (this.isReceipt) {
        arr.forEach((el) => {
          if (el.agent_type != 0) countAgentType++;
          if (el.supplier != "") {
            el.supplier = JSON.parse(el.supplier);
            if (el.supplier.phone_numbers) el.supplier["phone_numbers"] = el.supplier["phone_numbers"].join(", ");
          }
          el.amount = parseFloat(el.amount / 100);
          el.selected = true;
          this.amount += el.amount;
        });
      }

      document.documentElement.style.overflow = "hidden";
      this.refundForm.goodsList = _.extend(arr);
      this.hasAgentType = countAgentType > 0;
    },
    closeDialog() {
      this.loading = false;
      this.showError = false;
      this.refundForm.goodsList = [];
      this.amountRefund = 0;
      this.refundForm.email = 0;
      document.documentElement.style.overflow = "auto";
    },
    handleInputAmount(value) {
      this.showError = false;
    },
    handleCheckAllChange(val) {
      this.showError = false;
      this.isIndeterminate = false;
      this.refundForm.goodsList.forEach((el) => {
        el.selected = val;
      });
    },
    handleCheckedGoodsChange(e, item) {
      this.showError = false;
      let checkedCount;
      checkedCount = this.refundForm.goodsList.filter((el) => el.selected == true).length;
      this.checkAll = checkedCount === this.refundForm.goodsList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.refundForm.goodsList.length;
    },
    showSplitTable() {
      return this.isSplit && this.splitList.length > 0;
    },
    updateSplitTotal(value) {
      this.splitAmount = value.amount;
      this.splitListRefund = value.list;
      this.showError = false;
    },
  },
  mounted() {},
  components: {
    Money,
    splitTable,
  },
};
</script>

<style lang="sass">
.refundDialog .el-dialog
  margin-top: 30px !important
  .el-dialog__header
    border-bottom: 1px solid #eee
  .el-dialog__title
    font-weight: bold
    font-size: 16px
.break-word
  word-break: break-word
  line-height: 1.2
.refundForm
  .el-form-item
    margin-bottom: 0px
  .el-form-item__error
    position: relative
.refundtable
  margin-top: 5px
  .el-table__expanded-cell
    border-left: 48px solid #F6F9FC !important
    padding: 20px 15px !important
    cursor: default !important
  label
    margin-bottom: 0px
.refundResult
  .el-dialog__body
    padding-top: 10px
</style>
